/**
 * Billing QueryOptions — Layer 2. Reusable, typed query-option factories.
 */
import { queryOptions } from "@tanstack/react-query";
import { getBillingPlans, getSubscription } from "./billingApi";
import { billingKeys } from "@/shared/lib/queryKeys";

export const billingPlansQueryOptions = queryOptions({
  queryKey: billingKeys.plans(),
  queryFn: getBillingPlans,
  staleTime: 1000 * 60 * 60, // 1h — prices change rarely
  retry: false,
});

export const subscriptionQueryOptions = queryOptions({
  queryKey: billingKeys.subscription(),
  queryFn: getSubscription,
  staleTime: 1000 * 30,
  retry: false,
});
